import { render, staticRenderFns } from "./ChatPaletteTile.vue?vue&type=template&id=28486953&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteTile.vue"
export default component.exports